
$('.slider_wrapper').slick({
  infinite: true,
  dots:true,
  arrows:true,
  speed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.logo_slider ul').slick({
  infinite: true,
  dots:false,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows:false,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
})


$('.collection .slider-mobile-gutter ul').slick({
  infinite: true,
  dots:true,
  arrows:true,
  centerMode: true,
  centerPadding: '150px',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        centerPadding: '50px',
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerPadding: '30px',
        slidesToScroll: 1
      }
    }
  ]
});


$('.tab-a').click(function(){  
  $(".tab").removeClass('tab-active');
  $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
  $(".tab-a").removeClass('active-a');
  $(this).parent().find(".tab-a").addClass('active-a');
});
$(".accordion-head").click(function(){
  if($(this).parent().hasClass("active")){
    $(this).parent().removeClass("active");
    $(this).siblings(".accordion-body").slideUp();
  } else {
    $(".accordion-body").slideUp();
    $(".accordion").removeClass("active");
    $(this).parent().addClass("active");
    $(this).siblings(".accordion-body").slideDown();
  }
})

jQuery(".footer-block__heading").click(function(){
  if($(window).width() <= '749'){
  if(jQuery(this).hasClass("show"))
		{
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
		{
          jQuery(".footer-block__heading").removeClass("show");
          jQuery(".footer-block__heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
    }
});


document.addEventListener("DOMContentLoaded", function() {
	    var endlessScroll = new Ajaxinate({
	      container: '#Huratips-Loop',
	      pagination: '#Huratips-Pagination'
	    });
	  });

